import styled from 'styled-components';
import { AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import { HiOutlinePlus } from 'react-icons/hi';
import { FaAngleDown } from 'react-icons/fa6';

export const FAQContainer = styled.div`
  width: 100%;
  padding: ${(props) => (props.isFrom === 'referAndEarn' || props.isFrom === 'certificate' ? '40px 0px' : '35px 20px')};
  background: ${(props) => (props.isFromInterview || props.darkTheme ? 'none' : 'var(--siteBgColor)')};
  @media (min-width: 992px) {
    padding: 40px 0px;
  }
`;

export const AccordionOuter = styled.div`
  width: 100%;
  max-width: var(--layoutMaxWidth);
  margin: 0 auto;
  @media (min-width: 992px) {
    width: ${(props) => (props.isFrom === 'referAndEarn' || props.isFrom === 'certificate' ? '100%' : 'var(--layoutWidth)')};
  }
`;

export const FAQTitle = styled.h2`
  font-weight: 600 !important;
  padding-bottom: 30px;
  display: inline-block;
  color: ${({ isFromInterview, darkTheme }) => (isFromInterview || darkTheme ? 'white' : 'var(--inputTxtColor)')};
  background: ${({ isFromInterview, darkTheme, variant }) =>
    isFromInterview || darkTheme || variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors'
      ? ''
      : 'linear-gradient(90deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor))'};
  -ms-background-clip: ${({ isFromInterview, darkTheme, variant }) =>
    isFromInterview || darkTheme || variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? '' : 'text'};
  -webkit-background-clip: ${({ isFromInterview, darkTheme, variant }) =>
    isFromInterview || darkTheme || variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? '' : 'text'};
  background-clip: ${({ isFromInterview, darkTheme, variant }) =>
    isFromInterview || darkTheme || variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? '' : 'text'};
  -webkit-text-fill-color: ${({ isFromInterview, darkTheme, variant }) =>
    isFromInterview || darkTheme || variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? '' : 'transparent'};
`;

// accordian
export const AccordionItemContainer = styled(AccordionItem)`
  background-color: ${({ isExpanded, isFromInterview, darkTheme, theme, variant }) =>
    isFromInterview
      ? '#212020'
      : darkTheme
      ? theme.cardBg
      : variant === 'partner-plus' && isExpanded
      ? 'var(--partnerPlusColor)'
      : variant === 'partner-plus'
      ? 'var(--partnerLightBg)'
      : variant === 'regionals' && isExpanded
      ? 'var(--regionalsColor)'
      : variant === 'regionals'
      ? 'var(--regionalsLightBg)'
      : variant === 'code-juniors' && isExpanded
      ? 'var(--codeJuniorsColor)'
      : variant === 'code-juniors'
      ? 'var(--juniorsLightBg)'
      : isExpanded
      ? 'var(--brandColor)'
      : 'var(--greyBgLight)'};
  color: ${({ isExpanded, isFromInterview, darkTheme }) => (isFromInterview || darkTheme ? 'var(--light)' : isExpanded ? 'white' : 'var(--normalTxtColor)')};
  border-radius: 12px;
  margin-bottom: 20px;
  transition: 0.2s;
  :last-child {
    margin-bottom: 0px;
  }
`;

// questions div contaner
export const AccordionTitle = styled(AccordionItemHeading)`
  width: 100%;
  display: grid;
  grid-template-columns: 100%;
  cursor: pointer;
  :focus {
    outline: none;
  }
`;

export const TitleWrapper = styled(AccordionItemButton)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 25px;
  :focus {
    outline: none;
  }
`;

//questions
export const TitleContent = styled.div`
  width: 100%;
  margin-right: 10px;
  font-weight: ${({ isExpanded }) => (isExpanded ? '600' : '400')};
  font-size: 15px;
  @media (min-width: 576px) {
    font-size: 16px;
  }
`;

export const AccordionExpand = styled(HiOutlinePlus)`
  font-size: 20px;
  color: ${({ isExpanded, isFromInterview, darkTheme }) => (isFromInterview || darkTheme ? 'var(--secondaryWhite)' : isExpanded ? 'white' : 'var(--normalTxtColor)')};
  transition: transform 0.3s;
  transform: ${({ isExpanded }) => (isExpanded ? 'rotateZ(45deg)' : 'rotateZ(0deg)')};
`;

export const AccordionDropIcon = styled(FaAngleDown)`
  font-size: 18px;
  color: ${({ isExpanded, isFromInterview, darkTheme }) => (isFromInterview || darkTheme ? 'var(--secondaryWhite)' : isExpanded ? 'white' : 'var(--normalTxtColor)')};
  transition: transform 0.3s;
  transform: ${({ isExpanded }) => (isExpanded ? 'rotateZ(180deg)' : 'rotateZ(0deg)')};
`;

// answers
export const AccordionBody = styled(AccordionItemPanel).attrs({ className: 'accordion__body' })`
  padding: 0px 50px 20px 25px;
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  @media (min-width: 576px) {
    font-size: 15px;
  }
`;
